import { useEffect, useState } from "react"

import { useAppState } from "../../context/appStateContext"
import CloseButton, { CloseButtonProps } from "../CloseButton/CloseButton"
import styles from "./DelayedCloseButton.module.scss"

const DelayedCloseButton = (props: CloseButtonProps) => {
  const { state } = useAppState()
  const [hideOnLoaded, setHideOnLoaded] = useState(true)

  const fadeTime = state.productData?.closeFadeTime ?? 0

  useEffect(() => {
    if (state.fullyLoaded && fadeTime > 0) {
      const timer = setTimeout(() => {
        setHideOnLoaded(false)
      }, 1000 * fadeTime)

      return () => clearTimeout(timer)
    }
  }, [state.fullyLoaded, fadeTime])

  let shouldShow = !hideOnLoaded && state.fullyLoaded
  shouldShow = shouldShow || fadeTime == 0

  const style = shouldShow ? styles.visible : styles.hidden

  return <CloseButton className={`${style} ${props.className}`} onClick={props.onClick} />
}

export default DelayedCloseButton
